import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', label: '首页', icon: 'ri-home-4-line' },
  { path: '/category/all', label: '分类', icon: 'ri-grid-line' },
  { path: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200 py-2'
          : 'bg-transparent py-3'
      }`}
    >
      <nav className="w-full px-4 md:px-6 flex items-center justify-between max-w-[1400px] mx-auto">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-book-open-line text-background-50 text-lg"></i>
          </div>
          <span className="text-lg font-bold text-foreground-900 whitespace-nowrap font-heading">
            虚空韩漫网
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(item.path)
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                <i className={`${item.icon} text-base`}></i>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
            <i className="ri-search-line text-foreground-600"></i>
          </button>
          <Link
            to="/category/all"
            className="flex items-center gap-1.5 px-5 py-2 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line"></i>
            开始阅读
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-600 text-lg`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-in slide-in-from-top-2 duration-200">
          <ul className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive(item.path)
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  <i className={`${item.icon} text-base`}></i>
                  {item.label}
                </Link>
              </li>
            ))}
            <li className="pt-2">
              <Link
                to="/category/all"
                className="flex items-center justify-center gap-2 px-4 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold"
              >
                <i className="ri-play-circle-line"></i>
                开始阅读
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}